import { useState } from "react";

const quickTags = ["蹲后续", "剧组路透", "综艺现场", "红毯前线", "音乐现场", "素人暖闻"];

export default function Hero() {
  const [q, setQ] = useState("");

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20playful%20still-life%20of%20fresh%20watermelon%20slices%20on%20a%20warm%20cream%20background%2C%20scattered%20seeds%20and%20green%20leaves%2C%20bright%20natural%20light%2C%20minimal%20flat%20lay%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20warm%20tonal%20palette&width=1920&height=1080&seq=hero-melon-main&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/92 via-background-50/78 to-primary-100/55"></div>
        <div className="watermelon-stripe absolute inset-0 opacity-60"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-6 md:pb-24 md:pt-40">
        <a
          href="#hot"
          className="mb-6 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-medium text-primary-600 backdrop-blur transition-colors hover:border-primary-300 hover:bg-primary-50"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
          </span>
          群众在线中 · 今日热瓜持续上新
        </a>

        <h1 className="font-display text-4xl leading-tight text-foreground-950 sm:text-5xl md:text-6xl">
          今天，你<span className="text-primary-500">吃瓜</span>了吗？
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          吃瓜52是我爱吃瓜人群的日常打卡与在线等瓜聚集地。每天看看今天看什么、蹲一个后续、
          在线等瓜，围观群众实时更新线索，热门事件脉络整理，让你随时有瓜吃、有瓜可蹲。
        </p>

        <div className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
          <div className="flex flex-1 items-center gap-2 rounded-full border border-foreground-200 bg-background-50 px-4 py-1 shadow-sm">
            <i className="ri-search-line text-foreground-400"></i>
            <input
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜索你想吃的话题…"
              aria-label="搜索吃瓜话题"
              className="w-full bg-transparent py-2.5 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-all hover:bg-primary-600"
          >
            <i className="ri-search-2-line"></i>开吃
          </button>
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-foreground-500">大家都在蹲：</span>
          {quickTags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setQ(t)}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50/80 px-3 py-1.5 text-xs font-medium text-foreground-600 backdrop-blur transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600"
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-10 grid w-full grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { icon: "ri-sun-line", num: "1286+", label: "今日热瓜线索" },
            { icon: "ri-flashlight-line", num: "158", label: "正在蹲后续" },
            { icon: "ri-team-line", num: "36万+", label: "围观群众" },
            { icon: "ri-heart-2-line", num: "99万+", label: "累计打卡" },
          ].map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center gap-1 rounded-2xl border border-background-200 bg-background-50/80 px-3 py-4 backdrop-blur"
            >
              <i className={`${s.icon} text-xl text-primary-500`}></i>
              <span className="font-display text-lg text-foreground-900">{s.num}</span>
              <span className="text-xs text-foreground-500">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}